"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionCard = void 0;
var core_api_1 = require("@ikegps/core-api");
var collection_title_1 = require("../../components/collection/collection.title");
var theme_1 = require("../../components/theme");
var dom_1 = require("../../dom");
var index_1 = require("../../i18n/index");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var highlighter_1 = require("../../services/util/highlighter");
var page_state_1 = require("../../state/page.state");
var tag_sort_state_1 = require("../../state/tag.sort.state");
var tag_card_checkbox_1 = require("../tag.card.checkbox/tag.card.checkbox");
var collection_card_style_1 = require("./collection.card.style");
(0, theme_1.addStyles)(collection_card_style_1.Style);
exports.CollectionCard = {
    view: function (state, tag, collectionSummary) {
        var hasLocation = collectionSummary.location != null;
        var attributes = exports.CollectionCard.getAttributes(state, collectionSummary, hasLocation);
        var titleText = collectionSummary.title || collectionSummary.subtitle;
        var title = hasLocation ? titleText : "".concat(titleText, " (").concat((0, index_1.Translate)(index_1.T.NO_LOCATION), ")");
        var isSubtitle = !collectionSummary.title && !!collectionSummary.subtitle;
        var selectedState = {
            isSelected: function () { return page_state_1.CurrentState.Tag.isCollectionSelected(tag.objectId, collectionSummary.uuid); },
            setSelected: function (selected) { return page_state_1.CurrentState.Tag.selectCollection(tag.objectId, collectionSummary.uuid, selected); }
        };
        var children = [
            tag_card_checkbox_1.TagCardCheckbox.view(state, selectedState, tag, null, services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLOR_FLAG) ? collectionSummary.mapMarkerColor : null),
            (0, mithril_1.m)('span', {
                className: isSubtitle ? "".concat(collection_card_style_1.CSS.link, " ").concat(collection_card_style_1.CSS.isSubtitle) : collection_card_style_1.CSS.link,
                title: title
            }, exports.CollectionCard.viewTitle(collectionSummary))
        ];
        var sortValue = tag_sort_state_1.TagSortState.getCollectionDisplayValue(collectionSummary);
        if (sortValue != null) {
            if (sortValue instanceof Date) {
                sortValue = services_1.Services.DateTime.formatDateTime(sortValue);
            }
            children.push((0, mithril_1.m)('div', { className: collection_card_style_1.CSS.info, title: (0, index_1.Translate)(tag_sort_state_1.TagSortState.option.title) }, sortValue));
        }
        return (0, mithril_1.m)('div', attributes, children);
    },
    getAttributes: function (state, collectionSummary, hasLocation) {
        var _a;
        var isHovered = page_state_1.CurrentState.hoverId === collectionSummary.revision ? collection_card_style_1.CSS.isHovered : '';
        var isInspected = page_state_1.CurrentState.inspectedCollectionRevision === collectionSummary.revision ? collection_card_style_1.CSS.isInspected : '';
        var isNotLocated = hasLocation ? '' : collection_card_style_1.CSS.noLocation;
        return _a = {
                key: 'cc-' + collectionSummary.revision,
                className: "".concat(collection_card_style_1.CSS.container, " ").concat(isHovered, " ").concat(isInspected, " ").concat(isNotLocated)
            },
            _a[dom_1.DRAGON_ID] = collectionSummary.revision,
            _a[dom_1.DRAGON_TYPE] = dom_1.DragonDomTypes.COLLECTION,
            _a.onclick = function () { return state.map.zoomToCollection(collectionSummary.revision); },
            _a;
    },
    viewTitle: function (collectionSummary) {
        var title = collectionSummary.title || collectionSummary.subtitle;
        if (title == null) {
            return collection_title_1.CollectionTitle.view(collectionSummary.title);
        }
        if (services_1.Services.Search.filterState.hasFilter()) {
            return highlighter_1.Highlighter.highlight(title, services_1.Services.Search.filterState.filter).parts
                .map(function (part) { return (0, mithril_1.m)('span', { className: part.highlighted ? collection_card_style_1.CSS.filterMatch : null }, part.content); });
        }
        return title;
    }
};
//# sourceMappingURL=collection.card.js.map